<div>
	@if (loading) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}

	@if (!loading) {
		<div>
			<hr />
			<div class="active-date-range">
				<div>
					<label>Active Start Date:</label>
					<nz-date-picker
						[(ngModel)]="activeStartDate"
						nzPlaceHolder="Start Date"
						[nzAllowClear]="true"
					></nz-date-picker>
				</div>
				<div>
					<label>Active End Date:</label>
					<nz-date-picker
						[(ngModel)]="activeEndDate"
						nzPlaceHolder="End Date"
						[nzAllowClear]="true"
					></nz-date-picker>
				</div>
			</div>
			<div class="active-checkbox">
				<label [(ngModel)]="active" nz-checkbox>Active</label>
			</div>
			<hr />
			<app-field-label>Client</app-field-label>
			<app-client-selector
				(onSelect)="onClientSelect($event)"
				[selectedUuid]="selectedClient?.uuid"
			></app-client-selector>
			<br />
			<app-field-label>Groups</app-field-label>
			<app-cognito-group-selector
				[allGroups]="groups"
				[selectedGroups]="selectedGroups"
				(onChange)="onGroupsChanged($event)"
			></app-cognito-group-selector>
			<br />
			@if (selectedClient?.uuid) {
				<app-field-label>Sections</app-field-label>
				<app-sections-selector
					[selectedClients]="selectedClient ? [selectedClient] : []"
					[selectedSectionUuids]="selectedSectionUuids"
					(onChange)="onSectionsChanged($event)"
				></app-sections-selector>

				<div class="buttons">
					<button
						nz-button
						nzType="primary"
						[disabled]="!selectedClient || !selectedGroups || selectedGroups.length === 0"
						(click)="onSubmit$()"
					>
						Submit
					</button>
				</div>
			}
		</div>
	}
</div>
